import React, { Fragment, useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { getDevice } from "../../action/report";
import Alert from "../layout/Alert";
import ResponsiveContentWrapper from "../layout/ResponsiveContentWrapper";
import LineTestUserDeviceDetails from './DeviceDetails';
import customConfig from "../../config";
import BarcodeScanner from "../Common/scanner/BarcodeScanner";
import { getQRDetailsUsingScanner } from "../../action/qrcode";
import { setAlert } from "../../action/alert";
import ScannerGunIcon from './../../assets/scanner_gun_icon.png';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";
import useClearAlertsOnChange from "../../hooks/useClearAlertsOnChange";

const activeTabSx = {
  border: '1px solid #bdbdbd',
  backgroundColor: '#e0e0e0',
  color: '#333333',
  textTransform: 'capitalize'
};
const nonActiveTabSx = {
  border: 'none',
  backgroundColor: 'none',
  color: '#333333',
  textTransform: 'capitalize'
};
const scannerSectionSx = {
  width: "100%",
  mt: { xs: 1.5, sm: 2 },
};
const scannerContainerSx = {
  width: "100%",
  maxWidth: { xs: "100%", sm: 420, md: 500 },
};
const scannerLabelSx = {
  display: "block",
  textAlign: "left",
  mt: 0.5,
  wordBreak: "break-word",
};

const LineTestUserSearchDevice = ({
  setAlert,
  deviceId,
  getDevice,
  DeviceData: {
    device
  },
  wrapperClass = deviceId ? "" : "right-content-wraper",
  userRoleInfo,
  user: { user },
  tenant: { tenantInfo },
}) => {
  const [activeTab, setActiveTab] = React.useState(2)

  useClearAlertsOnChange(activeTab);

  const location = useLocation();
  const [text, setText] = useState("");
  const [showText, setShowText] = useState(false);
  const [usbBasedScannerInputField, setUsbBasedScannerInputFiled] = useState("")
  const usbBasedScannerInput = useRef(null)
  const [scanningInProgress, setScanningInProgress] = useState(false)
  const [qrScanningError, setQRScanningError] = useState(false)

  useEffect(() => {
    if (deviceId) {
      setText(deviceId);
      setShowText(false);
      device = null;
      getDevice(deviceId, customConfig.deviceSearchByDeviceId, userRoleInfo, tenantInfo.tenantId, false);
    }
    else {
      if (!showText && location.state) {
        setShowText(true);
      }
    }
  }, []);

  useEffect(() => {
    if (text.length > 0 && device && device.length > 0) {
      setShowText(true);
      setText("");
      setUsbBasedScannerInputFiled("")
      setActiveTab(2)
      setScanningInProgress(false)
    }
    else if (text.length > 0 && device && !Array.isArray(device)) {
      // there is some error while getting the device details
      setShowText(true);
      setText("");
      setUsbBasedScannerInputFiled("")
      setActiveTab(2)
      setScanningInProgress(false)
    }
  }, [device]);

  useEffect(() => {

    if (activeTab===1) {
      usbBasedScannerInput.current.focus()
      setShowText(false);
      setText("");
    }
    else if (activeTab===0) {
      setShowText(false);
      setText("");
    }
  }, [activeTab])

  function handleQRCodeScanDetails(data) {
    setShowText(false);
    device = null;
    setScanningInProgress(true)
    setQRScanningError(false)

    if (data.toString().substring(0, 2)==="MT") {
      if (data.substring(0, 3)==="MT;") {
        data = data.replace("MT;", "MT:")
      }

      getQRDetailsUsingScanner(data)
        .then((qrCodeScannedResult) => {
          if (qrCodeScannedResult.productSerialNumber) {
            setText(qrCodeScannedResult.productSerialNumber)
            getDevice(qrCodeScannedResult.productSerialNumber, customConfig.deviceSearchByProductSerialNumber, userRoleInfo, tenantInfo.tenantId, false)
          }
          else {
            setAlert("Cannot Scan QR Code. Scanned QR Code is Model ID Based QR Code", "danger")
            setShowText(true);
            setScanningInProgress(false)
            setActiveTab(2)
            setUsbBasedScannerInputFiled("")
            setQRScanningError(true)
          }
        })
        .catch((error) => {
          setAlert("Failed to Scan QR Code", "danger")
          setShowText(true);
          setScanningInProgress(false)
          setActiveTab(2)
          setUsbBasedScannerInputFiled("")
          setQRScanningError(true)
        })
    }
    else {
      setText(data)
      getDevice(data, customConfig.deviceSearchByProductSerialNumber, userRoleInfo, tenantInfo.tenantId, false);
    }
  }

  return (
    <ResponsiveContentWrapper className={wrapperClass || ""}>
      <div className="container">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div className="content-block bottom-shadow search-layout-2 mb-0">
              <div className="p-15">
                <Grid container spacing={2} className="srch-device-reset mb-0">
                    <Grid item xs={12} md={3}>
                      <div className="page-title">
                        <div className="black-text font-600" style={{ lineHeight: 'normal' }}>
                          Search Device Using Webcam or USB Scanner
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} md={5}>
                      <Tabs
                        value={activeTab}
                        onChange={(e, newValue) => {
                          setActiveTab(newValue)
                        }}
                        TabIndicatorProps={{
                          style: {
                            backgroundColor: "#bdbdbd",
                            float: 'right'
                          }
                        }}
                        sx={{ mt: { xs: 0, sm: 0.5, md: 2 } }}
                        variant="scrollable"
                        scrollButtons="auto"
                      >
                        <Tab
                          label={
                            activeTab===0 && scanningInProgress ? "Scanning In Progress" : "Scan Using Webcam Scanner"
                          }
                          icon={<i className="fa fa-qrcode fa-3x"></i>}
                          sx={{
                            ...(activeTab == 0 ? activeTabSx : nonActiveTabSx),
                            border: "1px solid black",
                            mr: 1,
                            minHeight: { xs: 52, sm: 56 },
                            px: { xs: 1, sm: 1.25 },
                          }}
                          title="Click to Scan QR Code or Barcode Using Webcam"
                          disabled={scanningInProgress ? true : false}
                        />
                        <Tab
                          label={
                            activeTab===1 && scanningInProgress ? "Scanning In Progress" : "Scan Using USB Scanner"
                          }
                          icon={<img src={ScannerGunIcon} style={{ width: '40px', height: "40px", cursor: "pointer" }} />}
                          sx={{
                            ...(activeTab == 1 ? activeTabSx : nonActiveTabSx),
                            border: "1px solid black",
                            mr: 1,
                            minHeight: { xs: 52, sm: 56 },
                            px: { xs: 1, sm: 1.25 },
                          }}
                          title="Click to Scan QR Code or Barcode Using USB Scanner"
                          disabled={scanningInProgress ? true : false}
                        />
                      </Tabs>
                    </Grid>
                    {activeTab == 0 && !scanningInProgress && (
                      <Grid item xs={12}>
                        <Box sx={scannerSectionSx}>
                          <Box sx={scannerContainerSx}>
                            <BarcodeScanner scanDetailsHandler={handleQRCodeScanDetails} />
                            <Box component="label" sx={scannerLabelSx}>
                              QR Code or Barcode Scanner
                            </Box>
                          </Box>
                        </Box>
                      </Grid>
                    )}
                    {activeTab == 1 && (
                      <Fragment>
                        <Grid item xs={12} style={{ width: '0px', height: '0px', overflow: 'hidden' }}>
                          <input
                            ref={usbBasedScannerInput}
                            value={usbBasedScannerInputField}
                            type="text"
                            style={{
                              opacity: 0,
                              width: 0,
                              height: '0px !important'
                            }}
                            onChange={(e) => {
                              setUsbBasedScannerInputFiled(e.target.value)
                              clearTimeout(window.focusTimeout)
                              window.focusTimeout = setTimeout(() => {
                                if (e.target.value && e.target.value.length > 0) {
                                  handleQRCodeScanDetails(e.target.value, true)
                                }
                              }, 500)
                            }}
                            onBlur={(e) => {
                              //focus the text field again if tab is active and data is not yet received
                              if (activeTab===1) {
                                e.target.focus()
                              }
                            }}
                          />
                        </Grid>
                      </Fragment>
                    )}
                </Grid>
              </div>
            </div>
          </Grid>
        </Grid>
        <div className="mid-seprator"></div>
        <Alert />
      </div>
      <div className={`search-device-page-container`}>
        <div style={{ marginTop: "15px", paddingTop: "0px" }}>
          <div className="container">
            <div className="row mb-0">
              <div className="s12 col no-side-padding">
                <div className="content-block position-relative">
                  <div className="p-15">
                    <div className="black-text font-600" style={{ lineHeight: 'normal' }}>
                      Scanning Status  :
                    </div>
                    <label style={{ color: 'black', marginLeft: '0px', display: "block", marginTop: "6px" }}>
                      {
                        activeTab===0 && scanningInProgress && "Webcam Scanning In Pogress"
                      }
                      {
                        activeTab===0 && !scanningInProgress && "Webcam Scanning Started"
                      }
                      {
                        activeTab !== 0 && !scanningInProgress && showText && "Scanning Completed. Please Click Above Button To Start Scanning Again"
                      }
                      {
                        activeTab===1 && scanningInProgress && "USB Scanning In Pogress"
                      }
                      {
                        activeTab===1 && !scanningInProgress && "USB Scanning Started"
                      }
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        {showText && !qrScanningError && device && Array.isArray(device) && device.length > 0 && (
          <div style={{ marginTop: "0px", paddingTop: "0px" }}>
            <div className="container">
              <div className="row mb-0">
                <div className="s12 p-0 col">
                  <div className="content-block position-relative" style={{ backgroundColor: 'green', padding: '25px' }}>
                    <div className="p-25">
                      <p style={{ fontSize: '22px', fontWeight: 'bold', textAlign: 'center', color: 'white' }}>Line Test Passed</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="device-detail-wrap device-info">
                <div className="row mb-0">
                  <div className="s12 p-0 col">
                    <div className="content-block position-relative">
                      <div className="p-15">
                        <LineTestUserDeviceDetails
                          device={device}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {showText && !qrScanningError && (device && !Array.isArray(device)) && (
          <div style={{ marginTop: "0px", paddingTop: "0px" }}>
            <div className="container">
              <div className="row mb-0">
                <div className="s12">
                  <div className="content-block position-relative" style={{ backgroundColor: 'red', padding: '25px' }}>
                    <div className="p-15">
                      <p style={{ fontSize: '22px', fontWeight: 'bold', textAlign: 'center', color: 'white' }}>Line Test Failed  - {device.msg}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </ResponsiveContentWrapper>
  );
};

const mapStateToProps = (state) => ({
  DeviceData: state.report,
  UserData: state.user,
  userRoleInfo: {
    level: state.auth.userLevel,
    roles: state.auth.userRoles,
  },
  user: state.user,
  tenant: state.tenant,
});

const mapDispatchToProps = (dispatch) => ({
  getDevice: (arg1, arg2, arg3, arg4, arg5, arg6) => dispatch(getDevice(arg1, arg2, arg3, arg4, arg5, arg6)),
  setAlert: (message, status) => dispatch(setAlert(message, status)),
})

export default connect(mapStateToProps, mapDispatchToProps)(LineTestUserSearchDevice);
